import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import axios from "axios";

const UserSignup = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [inputType, setInputType] = React.useState("password");
  const [loader, setLoader] = React.useState(false);
  const togglePassword = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const navigate = useNavigate();

  let name, value;
  const handleChange = (event) => {
    event.preventDefault();
    name = event.target.name;
    value = event.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (input) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(input);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { name, email, phone, password } = formData;
    if (!name || !email || !phone || !password) {
      toast.error("Please fill all fields!");
    } else if (!validateEmail(email)) {
      toast.error("Email Address is not invalid!");
    } else {
      setLoader(true);
      try {
        const response = await axios.post(`${apiUrl}createUserFT`, formData);
        const data = await response.data;
        if (data) {
          toast.success("Account created successfully!");
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        } else {
          toast.error("Account creation failed!");
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        toast.error("Something went wrong!");
      }
    }
  };
  return (
    <div>
      <Navbar />
      <div className="container">
        <ToastContainer />
        <form
          className="form-frontend"
          method="post"
          action="#"
          autocomplete="off"
        >
          <h1>Create Account</h1>
          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Email Address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Phone No.</label>
            <input
              type="tel"
              name="phone"
              className="form-control"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Password</label>
            <input
              type={inputType}
              name="password"
              className="form-control"
              placeholder="Set a password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <div className="togglePasswordIcon" onClick={togglePassword}>
              <span className="cursor-pointer text-gray-400">
                {inputType === "password" ? (
                  <VisibilityOffOutlinedIcon sx={{ fontSize: "17px" }} />
                ) : (
                  <VisibilityOutlinedIcon sx={{ fontSize: "17px" }} />
                )}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="btn-quote mt-3"
            onClick={handleSubmit}
          >
            Sign Up
            <LoginOutlinedIcon sx={{ fontSize: "20px", marginLeft: "10px" }} />
          </button>

          {loader && (
            <div className="loader-container">
              <div className="loader text-sm text-gray-400 text-center block">
                Request is in process please wait....
              </div>
            </div>
          )}

          <p className="mt-5 text-sm text-gray-500 hover:underline">
            <Link to="/login">Already have an account? Login</Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default UserSignup;
